import { render, staticRenderFns } from "./UnitForm.vue?vue&type=template&id=2837047c"
import script from "./UnitForm.vue?vue&type=script&lang=js"
export * from "./UnitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports